import { createWizardCampaignSelector } from 'containers/AwarenessCenter/constants'

const selfPath = (state) => createWizardCampaignSelector(state).generateEmailsStep

const selectLoader = (state) => selfPath(state)?.loader
const selectNotifyGenerationFinishedLoader = (state) =>
  selfPath(state)?.notifyGenerationFinishedLoader
const selectError = (state) => selfPath(state)?.error

/**
 * An alternative campaign id, stored inside GenerateEmail step to avoid triggering steps validation,
 * edit case and other related to self.campaign.id logic
 */
const selectCreatedSpearPhishingCampaignId = (state) =>
  selfPath(state)?.createdSpearPhishingCampaignId
const selectEmails = (state) => selfPath(state)?.emails
const selectLandingDomainList = (state) => selfPath(state)?.landingDomainList
const selectEmailUpdating = (state) => selfPath(state)?.emailUpdating
const selectEmailDetails = (state) => selfPath(state).emailDetails

const selectForcePoll = (state) => selfPath(state)?.forcePoll

export {
  selectLoader,
  selectNotifyGenerationFinishedLoader,
  selectError,
  selectCreatedSpearPhishingCampaignId,
  selectEmails,
  selectLandingDomainList,
  selectEmailUpdating,
  selectEmailDetails,
  selectForcePoll,
}
